// Mirrors functions/src/utils/requestCancel.ts (request-only checks). Keep both in step.
import type { SongRequest } from '../services/requests';

export type RequestCancelBlock = 'not-yours' | 'status' | 'special' | 'in-player' | 'voted' | 'ranked';

export const REQUEST_CANCEL_BLOCKS: readonly RequestCancelBlock[] = ['not-yours', 'status', 'special', 'in-player', 'voted', 'ranked'];

const CANCELLABLE_STATUSES: readonly SongRequest['status'][] = ['pending', 'queued', 'overflow'];

export type CancellableRequest = Pick<
  SongRequest,
  'status' | 'requestedBy' | 'superRequest' | 'prizeSkipTheLine' | 'prizeId' | 'queuedInPlayer' | 'queuedInSpotify' | 'lockedNext'
>;

const CANCEL_BLOCK_MESSAGES: Record<RequestCancelBlock, string> = {
  voted: 'Others have voted for this song, so it stays in.',
  ranked: 'Others have ranked this song, so it stays in.',
  'in-player': 'The DJ has already lined this song up.',
  special: "Nominations and prize picks can't be cancelled.",
  status: "This song has already played or isn't active.",
  'not-yours': 'You can only cancel your own requests.',
};

export function requestOnlyCancelBlock(request: CancellableRequest, attendeeId: string): RequestCancelBlock | null {
  if (request.requestedBy?.oderId !== attendeeId) return 'not-yours';
  if (!CANCELLABLE_STATUSES.includes(request.status)) return 'status';
  if (request.superRequest || request.prizeSkipTheLine || request.prizeId) return 'special';
  if (request.queuedInPlayer || request.queuedInSpotify || request.lockedNext) return 'in-player';
  return null;
}

export function isAttendeeCancelled(request: Pick<SongRequest, 'cancelledByAttendee'>): boolean {
  return request.cancelledByAttendee === true;
}

export function cancelBlockMessage(reason: RequestCancelBlock): string {
  return CANCEL_BLOCK_MESSAGES[reason];
}
